export const basic = '#2D2D2D';
export const green = '#4AD295';
export const red = '#EF5B5B';
export const warning = '#F6C98E';
